import { FieldRenderProps } from 'react-final-form';
import { useTranslation } from '../../modules/translation/TranslationContext';
import Select, { SelectProps } from '../FormInputs/Select/Select';
import Field from './Field';

type RFFSelectProps = Omit<SelectProps, 'ref'> & {
  name: string;
  defaultValue?: any;
  disabled?: boolean;
  error?: boolean;
  helperText?: string;
  variant?: 'filled' | 'outlined' | 'standard';
  showEmpty?: boolean;
  emptyLabel?: string;
};
/**
 * @deprecated React Final Form has been deprecated in the system.
 * Components based on RFF are no longer supported.
 * Please use <Select /> or other updated alternatives.
 */
const RFFSelect = ({ defaultValue, name, ...other }: RFFSelectProps) => {
  const { translate } = useTranslation();
  return (
    <Field defaultValue={defaultValue} name={name}>
      {({
        input,
        meta,
        ...props
      }: FieldRenderProps<string, HTMLInputElement | HTMLTextAreaElement>) => (
        <Select
          {...input}
          {...props}
          {...other}
          error={meta.error && meta.touched}
          value={input.value}
          onChange={input.onChange}
          onBlur={input.onBlur}
          helperText={other.helperText || (meta.touched && meta.error && translate(meta.error))}
        />
      )}
    </Field>
  );
};

export default RFFSelect;
